import type { ReactNode } from "react";
import type { Entity } from "@kkindex/shared";
import { Draggable, Drop } from "./components";
import s from "./App.module.css";

export function TaskRow({
  item,
  disabled,
  draggingTask,
  edit,
  children,
}: {
  item: Entity;
  disabled: boolean;
  draggingTask: boolean;
  edit: () => void;
  children: ReactNode;
}) {
  return (
    <div className={s.taskRowShell}>
      <Draggable
        item={item}
        id={`task:${item.id}`}
        selectionKey={`task:${item.id}`}
        onOpen={edit}
        disabled={disabled}
        data={{ surface: "task" }}
        className={`${s.taskRow} ${item.done ? s.done : ""}`}
      >
        {children}
      </Draggable>
      {draggingTask &&
        !disabled &&
        [false, true].map((after) => (
          <Drop
            key={String(after)}
            id={`task-${after ? "after" : "before"}:${item.id}`}
            accept={["task"]}
            label={`${after ? "放在下方" : "放在上方"}：${item.title}`}
            data={{
              surface: "task-order",
              itemId: item.id,
              parentId: item.parentId,
              after,
            }}
            className={`${s.taskDropZone} ${after ? s.taskDropAfter : s.taskDropBefore}`}
          >
            <span />
          </Drop>
        ))}
    </div>
  );
}
